import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetailsByID } from '../../../actions/users';
import { getUserRole } from '../../../utils/common';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';
import { NotFound } from './NotFound';
import { UserDetails } from '../../team/UserDetails';
import { headerComponent } from '../../team/TeamDetails';

export default function Details(props) {
    const { onClose, openTab, user_id, hideCloseButton = false } = props;
    let { selectedTeamUserDetails } = useSelector((state) => state.customer);
    const dispatch = useDispatch();
    const userDetailsById = useSelector((state) => state.user.userDetailsById);
    const isUserDetailsByIdLoading = useSelector((state) => state.loading.isUserDetailsByIdLoading);

    const memoizedSelectedTeamUserDetails = useMemo(() => {
        let data = selectedTeamUserDetails;
        if (user_id) {
            data = { id: user_id, name: 'User' };
        }
        return data;
    }, [selectedTeamUserDetails, user_id]);


    const memoizedUserDetails = useMemo(() => {
        let data = { user: {}, org: {} };
        if (userDetailsById[memoizedSelectedTeamUserDetails?.id]) {
            data = userDetailsById[memoizedSelectedTeamUserDetails?.id];
        }
        return data;
    }, [userDetailsById, memoizedSelectedTeamUserDetails]);

    useEffect(() => {
        if (memoizedSelectedTeamUserDetails && !userDetailsById[memoizedSelectedTeamUserDetails.id]) {
            dispatch(getUserDetailsByID({ user_id: memoizedSelectedTeamUserDetails.id }));
        }
    }, [memoizedSelectedTeamUserDetails, dispatch]);

    const defaultPic = process.env.PUBLIC_URL + './img/default-profile-pic.svg';
    const profile_pic = memoizedUserDetails.user.avatar_link;


    const getUserComponent = () => {
        if (isUserDetailsByIdLoading) return <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6]} height={15} className={'px-8'} />;
        if (memoizedUserDetails) {
            let userName = `${memoizedUserDetails.user.full_name ? memoizedUserDetails.user.full_name : ''}`;
            let address = memoizedUserDetails?.user?.address?.plain_text;
            const addressProof = memoizedUserDetails?.user?.address_proof_number?.length > 0 ? memoizedUserDetails?.user?.address_proof_number : false;
            const addressProofUrl = memoizedUserDetails?.user?.address_proof_url?.length > 0 ? memoizedUserDetails?.user?.address_proof_url : false;
            const addressProofUrlBack = memoizedUserDetails?.user?.address_proof_url_back?.length > 0 ? memoizedUserDetails?.user?.address_proof_url_back : false;
            const panAdharLinkStatus = memoizedUserDetails?.user?.is_pancard_linked_with_aadhaar

            return (
                <UserDetails
                    profile_pic={profile_pic ? profile_pic : defaultPic}
                    userRole={getUserRole(memoizedUserDetails.user.role, memoizedUserDetails.user.type)}
                    userName={userName}
                    email={memoizedUserDetails.user.email}
                    mobile={memoizedUserDetails.user.mobile}
                    SPName={memoizedUserDetails?.org?.name}
                    refferalCode={memoizedUserDetails.referral_code}
                    address={address}
                    pancard_number={memoizedUserDetails.user.pancard_number}
                    gst_number={memoizedUserDetails.user.gst_number}
                    aadhar_number={memoizedUserDetails.user.aadhaar_number}
                    documentFolderId={memoizedUserDetails.user.document_folder_id}
                    territories={memoizedUserDetails.user.territories}
                    tags={memoizedUserDetails.user.tags}
                    bankDetails={memoizedUserDetails.user.bank}
                    userProofImage={memoizedUserDetails.user.fe_adhar_card_image || memoizedUserDetails.user.sp_pan_card_image}
                    storeAffiliateLink={memoizedUserDetails.user.store_affiliate_link}
                    addressProof={addressProof}
                    addressProofUrl={addressProofUrl}
                    addressProofUrlBack={addressProofUrlBack}
                    panAdharLinkStatus={panAdharLinkStatus}
                    userDetails={memoizedUserDetails}
                    openTab={openTab}
                    kyc={memoizedUserDetails.user.kyc}
                    is_kyc_verified={memoizedUserDetails.user.is_kyc_verified}
                    walletDetails={memoizedUserDetails.user.wallet}
                    roles={memoizedUserDetails.user.roles || []}
                />
            );
        }
        return <NotFound />;
    };

    return (
        <>
            {headerComponent({ headName: 'User Details', onClick: onClose, hideCloseButton })}
            {getUserComponent()}
        </>
    );
}
